<template>
	<form class="form" @submit.prevent="submit" novalidate>
		<ValidationAlert :error-list="errors.collect('server')"></ValidationAlert>

		<div class="alert errors" v-if="importErrors">
			<strong>The uploaded csv file contains errors:</strong>

			<ul>
				<li v-for="(errors, row) in importErrors">
					<strong>Row #{{ row + 1 }}</strong>
					<span v-html="errors.join('<br />')"></span>
				</li>
			</ul>
		</div>

		<fieldset class="form__group" v-if="savedFormData.multiple">
			<legend>Create Multiple User Profiles</legend>
			<p>Upload a CSV file containing grouped information of all the users to automatically create multiple
				profiles at once. If you need help with the upload, <a href="">download the CSV Template here</a></p>

			<FileUpload label="Upload a CSV file" name="csv" v-model="formData.csv"
			            v-validate="'required'"></FileUpload>
			<FileUpload label="Upload a ZIP with the profile photos" name="zip" v-model="formData.zip"
			            v-validate="'required'"></FileUpload>

			<div class="form__group form__group--submit">
				<button class="btn" @click.prevent="back"
				        v-wait:disabled='["submit", "csv uploading", "zip uploading"]'>Back
				</button>
				<button class="btn btn--primary"
				        v-wait:disabled='["submit", "csv uploading", "zip uploading"]'>Create Users
				</button>
			</div>
		</fieldset>

		<fieldset class="form__group" v-else>
			<legend>Create a User Profile</legend>

			<div class="form__group">
				<input id="first-name" class="form__control" v-model="formData.firstName" v-validate required
				       name="firstName" placeholder="Enter the user's first name..."/>
				<label for="first-name" class="form__label">First name</label>
				<div class="form__validation">{{ errors.first('firstName') }}</div>
			</div>

			<div class="form__group">
				<input id="last-name" class="form__control" v-model="formData.lastName" v-validate required
				       name="lastName" placeholder="Enter the user's surname..."/>
				<label for="last-name" class="form__label">Surname</label>
				<div class="form__validation">{{ errors.first('lastName') }}</div>
			</div>

			<div class="form__group">
				<input id="position" class="form__control" v-model="formData.position" v-validate required
				       name="position" placeholder="Enter the user's job title..."/>
				<label for="position" class="form__label">Position</label>
				<div class="form__validation">{{ errors.first('position') }}</div>
			</div>

			<FormControlSector label="Sector specialisations" v-model="formData.specialisms" name="specialisms"
			                   :multiple="true">
			</FormControlSector>

			<FileUpload id="avatar" label="Profile picture" name="avatar" v-model="formData.avatar">
			</FileUpload>

			<div class="form__group">
				<input id="email" class="form__control" v-model="formData.email" v-validate required
				       name="email" placeholder="Enter the user's email address..."/>
				<label for="email" class="form__label">Email address</label>
				<div class="form__validation">{{ errors.first('email') }}</div>
			</div>

			<FormControlOffice label="Office location" placeholder="Select one of the company's offices"
			                   :member="savedFormData.member" v-model="formData.office" name="office"
			                   v-validate="'required'">
			</FormControlOffice>

			<div class="form__group form__group--submit">
				<button class="btn" @click.prevent="back" v-wait:disabled='["submit", "avatar uploading"]'>Back</button>
				<button class="btn btn--primary" v-wait:disabled='["submit", "avatar uploading"]'>Create User</button>
			</div>
		</fieldset>
	</form>
</template>

<script>
	import Vue from 'vue';
	import API from './../../../api';
	import ValidationAlert from '../../ValidationAlert';
	import FormControlMember from '../../Form/Control/FormControlMember';
	import UserCreateFormStep from './UserCreateFormStep';
	import FormControlSector from '../../Form/Control/FormControlSector';
	import FileUpload from '../../Form/FileUpload';
	import FormControlOffice from '../../Form/Control/FormControlOffice';

	export default {
		name: 'UserCreateFormStep2',
		components: {
			FormControlOffice,
			FileUpload,
			FormControlSector,
			FormControlMember,
			ValidationAlert,
		},
		mixins: [UserCreateFormStep],
		data() {
			return {
				formData: {
					member: null,
					csv: null,
					zip: null,
					firstName: null,
					lastName: null,
					position: null,
					specialisms: [],
					avatar: null,
					email: null,
					office: null,
					preview: true,
				},
				importErrors: null,
			}
		},
		methods: {
			save() {
				this.importErrors = null;

				if(this.savedFormData.multiple) {
					return API.importUsers(this.formData).then(imported => {
						this.$store.commit('form/mergeFormData', {
							imported,
						});

						return imported;
					}).catch(error => {
						if(error.response.status === 400) {
							Vue.set(this, 'importErrors', error.response.data);
						}

						throw error;
					});
				} else {
					return API.createUser(this.formData).then(response => {
						this.$store.commit('form/mergeFormData', {
							imported: [response.data.data],
						});

						return response;
					})
				}
			},
		},
		created() {
			this.formData.member = this.savedFormData.member;
		}
	}
</script>

<style lang="scss" scoped>
	.errors {
		li {
			margin-bottom: 1rem;
		}

		strong {
			display: block;
			margin-bottom: 0.5rem;
			font-weight: 500;
		}
	}
</style>
